import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { User } from '@commons/models/domain/User';
import { TranslateModule } from '@ngx-translate/core';
import { UserHttpService } from '@shared/services-http/user-http.service';
import { LanguageService } from '@shared/services/language.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-tachograph-permission-denied',
  standalone: true,
  imports: [TranslateModule, ButtonModule, CommonModule],
  templateUrl: './tachograph-permission-denied.component.html',
  styleUrls: ['./tachograph-permission-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TachographPermissionDeniedComponent {

  public emailIsSended: boolean;
  public imgSrc: string;

  private get user(): User | undefined {
    return this.userHttpService?.userViewModel?.user;
  }

  constructor(
    private userHttpService: UserHttpService,
    private languageService: LanguageService,
  ) {
    this.imgSrc = `${this.languageService.current}_tachograph.png`;
  }

  public sendEmail(): void {
    const email = "rozwoj@tekom.pl";
    const subject = "Zdalny odczyt z tachografu";
    const msgBody = `Jestem zainteresowany funkcją zdalnego odczytu plików z tachografu. Proszę o kontakt: ${ this.user?.Email }`;
    this.emailIsSended = true;
    window.open(`mailto:${email}?subject=${subject}&body=${msgBody}`);
  }
}
